(function () {
  var FACE_TO_FORM_TAGS = {
    oval: ["form_Aviador", "form_Cuadrado", "form_Rectangular", "form_Ovalado"],
    round: ["form_Cuadrado", "form_Gato", "form_Mariposa", "form_Rectangular"],
    square: ["form_Redondo", "form_Ovalado", "form_Gato", "form_Mariposa"],
    heart: ["form_Aviador", "form_Redondo", "form_Gato", "form_Mariposa"],
    oblong: ["form_Aviador", "form_Redondo", "form_Ovalado", "form_Gato", "form_Mariposa"],
    diamond: ["form_Cuadrado", "form_Redondo", "form_Ovalado"],
    triangular: ["form_Aviador", "form_Redondo", "form_Gato", "form_Mariposa"]
  };

  var STYLE_TO_VENDORS = {
    Clasico: ["Polo Ralph Lauren", "Brooks Brothers", "Fifth Avenue", "Seen"],
    Moderno: ["Guess", "Prive Revaux", "Unofficial", "Vogue", "Ray-Ban", "Michael Kors"],
    Deportivo: ["Oakley", "Puma", "Under Armour", "Costa", "Ferrari"],
    Elegante: ["Giorgio Armani", "Emporio Armani", "Carolina Herrera", "Michael Kors"],
    Vintage: ["Guess", "Prive Revaux", "Vogue", "Ray-Ban"],
    Casual: ["Polo Ralph Lauren", "Guess", "Prive Revaux", "Brooks Brothers"]
  };

  var STYLE_FILTER_TO_FORM_TAGS = {
    aviador: ["form_Aviador"],
    cuadrados: ["form_Cuadrado"],
    rectangulares: ["form_Rectangular"],
    ovalados: ["form_Ovalado"],
    redondos: ["form_Redondo"],
    "cat-eye": ["form_Gato", "form_Mariposa"]
  };

  var FORM_FILTER_VALUE_BY_TAG = {
    form_Aviador: "Aviador",
    form_Cuadrado: "Cuadrado",
    form_Gato: "Gato",
    form_Mariposa: "Mariposa",
    form_Ovalado: "Ovalado",
    form_Rectangular: "Rectangular",
    form_Redondo: "Redondo"
  };

  var COLLECTION_BASE_URLS = {
    mv: {
      Oftalmico: "https://www.masvision.mx/collections/todos-oftalmicos",
      Solar: "https://www.masvision.mx/collections/todos-solar"
    },
    lux: {
      Oftalmico: "https://www.lux.mx/collections/todos-oftalmicos",
      Solar: "https://www.lux.mx/collections/todos-solar"
    }
  };

  // Cada marca maneja su propia escala de precios.
  // min es limite inferior exclusivo, max es limite superior inclusivo, null = sin limite.
  var PRICE_FILTERS_BY_STOREFRONT = {
    mv: [
      { label: "Hasta $1,000", value: "under-1000", min: null, max: 1000 },
      { label: "$1,000 a $2,000", value: "between-1000-2000", min: 1000, max: 2000 },
      { label: "Más de $3,000", value: "over-3000", min: 3000, max: null }
    ],
    lux: [
      { label: "Hasta $2,000", value: "under-2000", min: null, max: 2000 },
      { label: "$2,000 a $4,500", value: "between-2000-4500", min: 2000, max: 4500 },
      { label: "Más de $4,500", value: "over-4500", min: 4500, max: null }
    ]
  };

  function getPriceFilters(config) {
    return PRICE_FILTERS_BY_STOREFRONT[normalizeStorefront(config && config.storefront)] || PRICE_FILTERS_BY_STOREFRONT.mv;
  }

  var MODE_TO_TYPE = {
    oftalmicos: "Oftalmico",
    solares: "Solar",
    todo: "Ambos"
  };

  var FACE_LABELS = {
    oval: "Ovalado",
    round: "Redondo",
    square: "Cuadrado",
    heart: "Corazón",
    oblong: "Ovalado",
    diamond: "Diamante",
    triangular: "Triangular"
  };

  var FEATURE_LABELS = {
    narrow: "Estrecho",
    medium: "Medio",
    wide: "Ancho",
    prominent: "Prominente",
    strong: "Fuerte",
    angular: "Angular",
    short: "Corto",
    long: "Largo",
    warm: "Cálido",
    cool: "Frío",
    neutral: "Neutro"
  };

  var BEST_STYLES = {
    oval: ["Aviador", "Cuadrados", "Rectangulares", "Ovalados"],
    round: ["Cuadrados", "Rectangulares", "Cat-eye"],
    square: ["Redondos", "Ovalados", "Cat-eye"],
    heart: ["Aviador", "Redondos", "Cat-eye"],
    oblong: ["Aviador", "Redondos", "Ovalados", "Cat-eye"],
    diamond: ["Cuadrados", "Redondos", "Ovalados"],
    triangular: ["Cat-eye", "Redondos", "Aviador"]
  };

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizeText(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function normalizeStorefront(value) {
    var normalized = normalizeText(value);
    return normalized === "lux" || normalized === "luxmx" || normalized === "lux.mx" ? "lux" : "mv";
  }

  function getApiUrl(config, path) {
    return String(config.apiBaseUrl || "").replace(/\/$/, "") + path;
  }

  function createId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return prefix + "_" + window.crypto.randomUUID();
    }
    return prefix + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function getStoredId(storage, key, prefix) {
    try {
      var existing = storage.getItem(key);
      if (existing) return existing;
      var next = createId(prefix);
      storage.setItem(key, next);
      return next;
    } catch (error) {
      return createId(prefix);
    }
  }

  function getTrackingContext(config) {
    var visitorId = getStoredId(window.localStorage, "style-spectacles:visitor-id", "visitor");
    var sessionId = getStoredId(window.sessionStorage, "style-spectacles:session-id", "session");
    var visitId = window.sessionStorage.getItem("style-spectacles:current-visit-id");
    var storefront = normalizeStorefront(config.storefront);

    return { visitorId: visitorId, sessionId: sessionId, visitId: visitId, storefront: storefront };
  }

  function buildPagePayload() {
    var params = new URLSearchParams(window.location.search);
    var query = {};

    params.forEach(function (value, key) {
      if (/^(utm_|gclid|fbclid|msclkid|source|campaign|medium|term|content)/i.test(key)) {
        query[key] = value;
      }
    });

    return {
      url: window.location.origin + window.location.pathname,
      path: window.location.pathname,
      queryKeys: Array.from(new Set(params.keys())),
      query: query
    };
  }

  function trackVisit(config) {
    var visitId = createId("visit");
    window.sessionStorage.setItem("style-spectacles:current-visit-id", visitId);

    var payload = {
      visitId: visitId,
      visitorId: getStoredId(window.localStorage, "style-spectacles:visitor-id", "visitor"),
      sessionId: getStoredId(window.sessionStorage, "style-spectacles:session-id", "session"),
      createdAt: new Date().toISOString(),
      storefront: normalizeStorefront(config.storefront),
      page: buildPagePayload(),
      referrer: document.referrer || null,
      browser: {
        userAgent: navigator.userAgent,
        platform: navigator.platform || null,
        vendor: navigator.vendor || null,
        cookieEnabled: navigator.cookieEnabled,
        doNotTrack: navigator.doNotTrack || null,
        online: typeof navigator.onLine === "boolean" ? navigator.onLine : null,
        hardwareConcurrency: navigator.hardwareConcurrency || null,
        deviceMemory: navigator.deviceMemory || null,
        maxTouchPoints: navigator.maxTouchPoints || null
      },
      locale: {
        language: navigator.language || null,
        languages: Array.isArray(navigator.languages) ? navigator.languages.filter(Boolean) : [],
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || null
      },
      screen: {
        width: window.screen ? window.screen.width : null,
        height: window.screen ? window.screen.height : null,
        viewportWidth: window.innerWidth || null,
        viewportHeight: window.innerHeight || null,
        pixelRatio: window.devicePixelRatio || null,
        colorDepth: window.screen ? window.screen.colorDepth : null
      },
      iframe: {
        isEmbedded: false,
        referrerHost: null,
        referrerPath: null,
        parentOrigin: window.location.origin
      },
      shopifyContext: {
        storefront: normalizeStorefront(config.storefront),
        shopDomain: config.shopDomain || null,
        customerId: config.customerId || null,
        loggedIn: Boolean(config.customerLoggedIn),
        source: config.source || "liquid"
      }
    };

    fetch(getApiUrl(config, "/api/iframe-visits"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }

  function trackEvent(config, type, details) {
    var context = getTrackingContext(config);
    var payload = Object.assign({
      eventId: createId("event"),
      type: type,
      visitId: context.visitId,
      visitorId: context.visitorId,
      sessionId: context.sessionId,
      createdAt: new Date().toISOString(),
      storefront: context.storefront,
      page: buildPagePayload(),
      shopifyContext: {
        storefront: context.storefront,
        shopDomain: config.shopDomain || null,
        customerId: config.customerId || null,
        loggedIn: Boolean(config.customerLoggedIn),
        source: config.source || "liquid"
      }
    }, details || {});

    fetch(getApiUrl(config, "/api/iframe-events"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }

  function formatMoney(amount) {
    var value = Number(amount || 0);
    return value.toLocaleString("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 0 });
  }

  function getRecommendedFormTags(faceShape, gender) {
    var formTags = FACE_TO_FORM_TAGS[faceShape] || [];
    if (gender === "Mujer") return Array.from(new Set(formTags));
    return Array.from(new Set(formTags.filter(function (tag) {
      return tag !== "form_Gato" && tag !== "form_Mariposa";
    })));
  }

  function getFormTagsForStyle(style) {
    if (!style) return [];
    return STYLE_FILTER_TO_FORM_TAGS[normalizeText(style)] || [];
  }

  function getFormFromTags(tags) {
    var tag = (tags || []).find(function (item) { return item.indexOf("form_") === 0; });
    return tag ? tag.replace("form_", "") : "";
  }

  function matchesPrice(price, filter, config) {
    var tiers = getPriceFilters(config);
    var tier = null;
    for (var i = 0; i < tiers.length; i += 1) {
      if (tiers[i].value === filter) { tier = tiers[i]; break; }
    }
    if (!tier) return false;
    if (tier.min !== null && !(price > tier.min)) return false;
    if (tier.max !== null && !(price <= tier.max)) return false;
    return true;
  }

  function buildShopifyQuery(prefs) {
    var parts = ["available_for_sale:true"];

    if (prefs.gender === "Mujer") parts.push("(tag:gen_Mujer OR tag:gen_Unisex)");
    else if (prefs.gender === "Hombre") parts.push("(tag:gen_Hombre OR tag:gen_Unisex)");
    else parts.push("tag:gen_Unisex");

    if (prefs.type === "Oftalmico") parts.push("(tag:type_Oftalmico OR tag:type_Oft\u00e1lmico OR tag:type_Optico)");
    if (prefs.type === "Solar") parts.push("tag:type_Solar");

    var formTags = getRecommendedFormTags(prefs.faceShape, prefs.gender);
    if (formTags.length) parts.push("(" + formTags.map(function (tag) { return "tag:" + tag; }).join(" OR ") + ")");

    var vendors = prefs.style ? STYLE_TO_VENDORS[prefs.style] : null;
    if (vendors && vendors.length) {
      parts.push("(" + vendors.map(function (vendor) { return 'vendor:"' + vendor + '"'; }).join(" OR ") + ")");
    }

    return parts.join(" AND ");
  }

  function fetchProducts(config, prefs) {
    return fetch(getApiUrl(config, "/api/shopify-products"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        shopifyQuery: buildShopifyQuery(prefs),
        storefront: normalizeStorefront(config.storefront),
        ageGroup: prefs.ageGroup,
        excludeKids: prefs.ageGroup === "adult" || prefs.ageGroup === "young"
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.error) throw new Error(json.error || "Error al conectar con la tienda");
          return (json.products || []).filter(function (product) {
            return product.availableForSale && product.onlineStoreUrl;
          });
        });
      });
  }

  function getVariantNumericId(globalId) {
    var match = String(globalId || "").match(/(\d+)(?:\?.*)?$/);
    return match ? match[1] : null;
  }

  function getProductUrl(config, product) {
    if (product.onlineStoreUrl) return product.onlineStoreUrl;
    var origin = normalizeStorefront(config.storefront) === "lux" ? "https://www.lux.mx" : "https://www.masvision.mx";
    return origin + "/products/" + product.handle;
  }

  function getAddToCartUrl(config, product) {
    var origin = product.storefrontUrl || (normalizeStorefront(config.storefront) === "lux" ? "https://www.lux.mx" : "https://www.masvision.mx");
    var variantId = getVariantNumericId(product.firstVariantId);
    return variantId ? origin + "/cart/" + variantId + ":1" : getProductUrl(config, product);
  }

  function buildCollectionLinks(config, analysis, selectedType, selectedStyleFilter) {
    var gender = analysis.gender === "female" ? "Mujer" : analysis.gender === "male" ? "Hombre" : "Unisex";
    var selectedFormTags = selectedStyleFilter ? getFormTagsForStyle(selectedStyleFilter) : getRecommendedFormTags(analysis.faceShape, gender);
    var types = selectedType === "Ambos" ? ["Oftalmico", "Solar"] : [selectedType];
    var bases = COLLECTION_BASE_URLS[normalizeStorefront(config.storefront)] || COLLECTION_BASE_URLS.mv;

    return types.map(function (type) {
      var params = new URLSearchParams();
      params.set("_", "pf");
      params.append("filter.p.tag", "gen_" + gender);
      selectedFormTags.forEach(function (tag) {
        var formValue = FORM_FILTER_VALUE_BY_TAG[tag];
        if (formValue) params.append("filter.p.tag", "form_" + formValue);
      });

      return {
        label: type === "Oftalmico" ? "Ver colección oftálmica con estos filtros" : "Ver colección solar con estos filtros",
        url: bases[type] + "?" + params.toString()
      };
    });
  }

  function renderUpload(instance) {
    var root = instance.root;
    root.innerHTML = [
      '<div class="ss-upload">',
      '  <label class="ss-dropzone" data-dropzone>',
      '    <input type="file" accept="image/*" data-file-input>',
      '    <span>',
      '      <span class="ss-upload-icon" aria-hidden="true">',
      '        <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.2" xmlns="http://www.w3.org/2000/svg">',
      '          <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h1.7l1.1-2h4.4l1.1 2H17a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3Z"/>',
      '          <circle cx="12" cy="13" r="3.2"/>',
      '        </svg>',
      '      </span>',
      '      <p class="ss-upload-title">Sube una foto de tu cara</p>',
      '      <p class="ss-upload-copy">Busca tener buena iluminación y que tu cara esté centrada y de frente</p>',
      '      <span class="ss-button ss-button--secondary">',
      '        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg">',
      '          <path stroke-linecap="round" stroke-linejoin="round" d="M12 16V4m0 0 4 4m-4-4-4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>',
      '        </svg>',
      '        Elegir archivo',
      '      </span>',
      '    </span>',
      '  </label>',
      '</div>'
    ].join("");

    var input = root.querySelector("[data-file-input]");
    var dropzone = root.querySelector("[data-dropzone]");
    var processFile = function (file) {
      if (!file || !file.type || file.type.indexOf("image/") !== 0) return;
      var reader = new FileReader();
      reader.onload = function (event) {
        instance.userImage = event.target.result;
        renderPreview(instance);
      };
      reader.readAsDataURL(file);
    };

    input.addEventListener("change", function (event) {
      processFile(event.target.files && event.target.files[0]);
    });

    dropzone.addEventListener("dragover", function (event) {
      event.preventDefault();
      dropzone.classList.add("is-dragging");
    });
    dropzone.addEventListener("dragleave", function () {
      dropzone.classList.remove("is-dragging");
    });
    dropzone.addEventListener("drop", function (event) {
      event.preventDefault();
      dropzone.classList.remove("is-dragging");
      processFile(event.dataTransfer.files && event.dataTransfer.files[0]);
    });
  }

  function renderPreview(instance) {
    instance.root.innerHTML = [
      '<div class="ss-preview">',
      '  <div class="ss-preview-image"><img src="' + escapeHtml(instance.userImage) + '" alt="Tu foto"></div>',
      '  <div class="ss-actions">',
      '    <button class="ss-button ss-button--secondary" data-mode="oftalmicos">Recomendar oftálmicos</button>',
      '    <button class="ss-button ss-button--secondary" data-mode="solares">Recomendar solares</button>',
      '    <button class="ss-button" data-mode="todo">Recomendar todo</button>',
      '    <button class="ss-button ss-button--secondary" data-reset>Usar otra foto</button>',
      '  </div>',
      '</div>'
    ].join("");

    instance.root.querySelector("[data-reset]").addEventListener("click", function () { reset(instance); });
    Array.from(instance.root.querySelectorAll("[data-mode]")).forEach(function (button) {
      button.addEventListener("click", function () { analyze(instance, button.getAttribute("data-mode")); });
    });
  }

  function setBusy(instance, isBusy) {
    Array.from(instance.root.querySelectorAll("button")).forEach(function (button) {
      button.disabled = isBusy;
    });
  }

  function analyze(instance, mode) {
    var selectedType = MODE_TO_TYPE[mode] || MODE_TO_TYPE[instance.config.defaultRecommendationMode] || "Ambos";
    instance.selectedType = selectedType;
    instance.selectedPriceFilter = null;
    instance.selectedStyleFilter = null;
    setBusy(instance, true);

    fetch(getApiUrl(instance.config, "/api/analyze-face"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ imageBase64: instance.userImage })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.error) throw new Error(json.error || "No pudimos analizar tu foto");
          return json;
        });
      })
      .then(function (analysis) {
        instance.analysis = analysis;
        var gender = analysis.gender === "female" ? "Mujer" : analysis.gender === "male" ? "Hombre" : "Unisex";
        return fetchProducts(instance.config, {
          gender: gender,
          type: selectedType,
          style: "",
          colorBucket: "",
          faceShape: analysis.faceShape,
          ageGroup: analysis.ageGroup
        });
      })
      .then(function (products) {
        instance.products = products;
        renderResults(instance);
      })
      .catch(function (error) {
        showAnalysisError(instance, error.message);
        setBusy(instance, false);
      });
  }

  // Un fallo del análisis no debe dejar recomendaciones inventadas en pantalla.
  function showAnalysisError(instance, message) {
    instance.analysis = null;
    instance.products = [];

    var previous = instance.root.querySelector(".ss-error");
    if (previous && previous.parentNode) previous.parentNode.removeChild(previous);

    var box = document.createElement("div");
    box.className = "ss-error";
    box.setAttribute("role", "alert");
    box.setAttribute("aria-live", "assertive");
    box.innerHTML = "<strong>No pudimos analizar tu foto</strong><br>" +
      escapeHtml(message || "Intenta de nuevo con otra imagen.");

    instance.root.insertAdjacentElement("afterbegin", box);

    if (typeof box.scrollIntoView === "function") {
      box.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  function renderResults(instance) {
    var analysis = instance.analysis;
    var genderLabel = analysis.gender === "male" ? "Hombre" : "Mujer";
    var availableStyles = (BEST_STYLES[analysis.faceShape] || []).filter(function (style) {
      if (analysis.gender !== "female" && normalizeText(style) === "cat-eye") return false;
      var tags = getFormTagsForStyle(style);
      return !tags.length || instance.products.some(function (product) {
        return (product.tags || []).some(function (tag) { return tags.indexOf(tag) >= 0; });
      });
    });

    instance.root.innerHTML = [
      '<div class="ss-results">',
      '  <div class="ss-analysis-layout">',
      '    <div>',
      '      <img class="ss-user-photo" src="' + escapeHtml(instance.userImage) + '" alt="Tu foto">',
      '      <button class="ss-button ss-button--secondary" data-reset style="width:100%;margin-top:12px;">Usar otra foto</button>',
      '    </div>',
      '    <div class="ss-panel">',
      '      <h3>Rostro ' + escapeHtml(FACE_LABELS[analysis.faceShape] || analysis.faceShape) + ' - ' + genderLabel + '</h3>',
      '      <p>' + escapeHtml(analysis.analysis || "") + '</p>',
      '      <div class="ss-feature-grid">',
      feature("Frente", analysis.features && analysis.features.foreheadWidth),
      feature("Pómulos", analysis.features && analysis.features.cheekbones),
      feature("Mandíbula", analysis.features && analysis.features.jawline),
      feature("Tono", analysis.features && analysis.features.skinTone),
      '      </div>',
      analysis.styleNotes ? '<div class="ss-panel" style="margin-top:12px;"><strong>Consejo de estilo</strong><p>' + escapeHtml(analysis.styleNotes) + '</p></div>' : '',
      '      <div style="margin-top:14px;"><strong>Estilos recomendados</strong><div class="ss-style-list" style="justify-content:flex-start;margin-top:10px;">' + availableStyles.map(function (style) {
        return '<button class="ss-button ss-button--secondary" data-style="' + escapeHtml(style) + '">' + escapeHtml(style) + '</button>';
      }).join("") + '</div></div>',
      '    </div>',
      '  </div>',
      '  <div>',
      '    <h3 class="ss-section-title">Armazones recomendados para ti</h3>',
      '    <div class="ss-price-filter">' + getPriceFilters(instance.config).map(function (filter) {
        return '<button class="ss-button ss-button--secondary" data-price="' + filter.value + '">' + filter.label + '</button>';
      }).join("") + '</div>',
      '    <div data-products style="margin-top:18px;"></div>',
      '    <div class="ss-collection-links" data-collections style="margin-top:18px;"></div>',
      '  </div>',
      '</div>'
    ].join("");

    instance.root.querySelector("[data-reset]").addEventListener("click", function () { reset(instance); });
    Array.from(instance.root.querySelectorAll("[data-style]")).forEach(function (button) {
      button.addEventListener("click", function () {
        var style = button.getAttribute("data-style");
        instance.selectedStyleFilter = instance.selectedStyleFilter === style ? null : style;
        renderProductList(instance);
      });
    });
    Array.from(instance.root.querySelectorAll("[data-price]")).forEach(function (button) {
      button.addEventListener("click", function () {
        instance.selectedPriceFilter = button.getAttribute("data-price");
        renderProductList(instance);
      });
    });

    renderProductList(instance);
  }

  function feature(label, value) {
    var safeValue = FEATURE_LABELS[value] || value || "Sin dato";
    return '<div class="ss-feature"><span>' + escapeHtml(label) + '</span><strong>' + escapeHtml(safeValue) + '</strong></div>';
  }

  function renderProductList(instance) {
    var container = instance.root.querySelector("[data-products]");
    var collectionContainer = instance.root.querySelector("[data-collections]");
    if (!container) return;

    if (!instance.selectedPriceFilter) {
      container.innerHTML = '<div class="ss-empty">Elige un rango de precio para ver tus recomendaciones.</div>';
      collectionContainer.innerHTML = "";
      return;
    }

    var styleTags = getFormTagsForStyle(instance.selectedStyleFilter);
    var products = instance.products.filter(function (product) {
      var styleMatch = !styleTags.length || (product.tags || []).some(function (tag) { return styleTags.indexOf(tag) >= 0; });
      var price = Number(product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount);
      return styleMatch && matchesPrice(price, instance.selectedPriceFilter, instance.config);
    }).slice(0, 24);

    if (!products.length) {
      container.innerHTML = '<div class="ss-empty">No encontramos modelos para ese rango. Prueba otro precio o estilo recomendado.</div>';
    } else {
      container.innerHTML = '<div class="ss-products">' + products.map(function (product, index) {
        var image = product.featuredImage && product.featuredImage.url ? product.featuredImage.url : "";
        var price = product.priceRange && product.priceRange.minVariantPrice ? product.priceRange.minVariantPrice.amount : 0;
        var addUrl = getAddToCartUrl(instance.config, product);
        return [
          '<article class="ss-product" data-product-index="' + index + '">',
          '  <div class="ss-product-media">',
          image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '',
          '    <span class="ss-product-vendor">' + escapeHtml(product.vendor || "") + '</span>',
          '  </div>',
          '  <div class="ss-product-body">',
          '    <h4 class="ss-product-title">' + escapeHtml(product.title) + '</h4>',
          '    <div class="ss-product-meta"><span>' + escapeHtml(getFormFromTags(product.tags || [])) + '</span><span class="ss-product-price">' + formatMoney(price) + '</span></div>',
          '    <div class="ss-product-actions">',
          instance.config.showPhotomontage ? '<button class="ss-button ss-button--secondary" data-try-on="' + index + '">Probar</button>' : '',
          '      <a class="ss-button" href="' + escapeHtml(addUrl) + '" target="_blank" rel="noopener" data-cart="' + index + '">Agregar al carrito</a>',
          '    </div>',
          '  </div>',
          '</article>'
        ].join("");
      }).join("") + '</div>';
    }

    Array.from(container.querySelectorAll("[data-cart]")).forEach(function (link) {
      link.addEventListener("click", function () {
        var product = products[Number(link.getAttribute("data-cart"))];
        trackEvent(instance.config, product.firstVariantId ? "add_to_cart" : "product_click", {
          product: buildTrackedProduct(instance.config, product, link.href),
          metadata: {
            selectedPriceFilter: instance.selectedPriceFilter,
            selectedStyleFilter: instance.selectedStyleFilter,
            renderedRecommendationCount: products.length
          }
        });
      });
    });

    Array.from(container.querySelectorAll("[data-try-on]")).forEach(function (button) {
      button.addEventListener("click", function () {
        var product = products[Number(button.getAttribute("data-try-on"))];
        generatePhotomontage(instance, product, button);
      });
    });

    var links = buildCollectionLinks(instance.config, instance.analysis, instance.selectedType, instance.selectedStyleFilter);
    collectionContainer.innerHTML = links.map(function (link, index) {
      return '<a class="ss-button" href="' + escapeHtml(link.url) + '" target="_blank" rel="noopener" data-collection="' + index + '">' + escapeHtml(link.label) + '</a>';
    }).join("");

    Array.from(collectionContainer.querySelectorAll("[data-collection]")).forEach(function (link) {
      link.addEventListener("click", function () {
        var item = links[Number(link.getAttribute("data-collection"))];
        trackEvent(instance.config, "collection_click", {
          collection: item,
          metadata: {
            selectedPriceFilter: instance.selectedPriceFilter,
            selectedStyleFilter: instance.selectedStyleFilter
          }
        });
      });
    });
  }

  function buildTrackedProduct(config, product, destinationUrl) {
    var price = product.priceRange && product.priceRange.minVariantPrice ? product.priceRange.minVariantPrice : {};
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      vendor: product.vendor,
      variantId: product.firstVariantId,
      destinationUrl: destinationUrl || getProductUrl(config, product),
      priceAmount: price.amount || null,
      currencyCode: price.currencyCode || null
    };
  }

  function generatePhotomontage(instance, product, button) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = "Generando...";

    fetch(getApiUrl(instance.config, "/api/generate-photomontage"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userImageBase64: instance.userImage,
        glassesName: product.title,
        glassesDescription: getFormFromTags(product.tags || []) + " shaped frame by " + product.vendor,
        glassesColor: "",
        glassesImageUrl: product.featuredImage && product.featuredImage.url ? product.featuredImage.url : ""
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.error) throw new Error(json.error || "No se pudo generar el fotomontaje");
          return json;
        });
      })
      .then(function (json) {
        var card = button.closest(".ss-product");
        var img = card && card.querySelector(".ss-product-media img");
        if (img && json.imageUrl) img.src = json.imageUrl;
      })
      .catch(function (error) {
        alert(error.message);
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = originalText;
      });
  }

  function reset(instance) {
    instance.userImage = "";
    instance.analysis = null;
    instance.products = [];
    instance.selectedPriceFilter = null;
    instance.selectedStyleFilter = null;
    renderUpload(instance);
  }

  function readConfig(section) {
    var script = section.querySelector("[data-style-spectacles-config]");
    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      return {};
    }
  }

  function initSection(section) {
    if (section.dataset.styleSpectaclesReady === "true") return;
    section.dataset.styleSpectaclesReady = "true";

    var config = readConfig(section);
    config.storefront = normalizeStorefront(config.storefront);

    var instance = {
      section: section,
      root: section.querySelector("[data-style-spectacles-root]"),
      config: config,
      userImage: "",
      analysis: null,
      products: [],
      selectedType: MODE_TO_TYPE[config.defaultRecommendationMode] || "Ambos",
      selectedPriceFilter: null,
      selectedStyleFilter: null
    };

    if (!config.apiBaseUrl) {
      instance.root.innerHTML = '<div class="ss-error">Configura la URL del endpoint en la sección.</div>';
      return;
    }

    trackVisit(config);
    renderUpload(instance);
  }

  function initAll() {
    Array.from(document.querySelectorAll("[data-style-spectacles]")).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target && event.target.querySelector("[data-style-spectacles]")
      ? event.target.querySelector("[data-style-spectacles]")
      : event.target;
    if (section && section.matches && section.matches("[data-style-spectacles]")) initSection(section);
  });
})();
